export default __webpack_public_path__ + "static/media/LagenOmEkonomiskaFöreningar.c46242f3.png";